import {Component, Input} from '@angular/core';
import {CustomImportComponentObject} from "../../../../shared/classes/custom-import-component-object";

@Component({
  selector: 'app-custom-sources-tooltip-file-info',
  templateUrl: './custom-sources-tooltip-file-info.component.html',
  styleUrls: ['./custom-sources-tooltip-file-info.component.scss']
})
export class CustomSourcesTooltipFileInfoComponent {
  @Input() public customImport: CustomImportComponentObject;
}
